import { GET_BY_ID } from 'redux/modules/address-suggestion/actions/types';

import addressSuggestionById from 'api/definitions/address-suggestion-by-id';

const iHandleStatusCodes = [400, 403, 404, 500, 503, 504];

export const getAddressBySuggestionId = suggestionId => async dispatch =>
  dispatch({
    types: GET_BY_ID.triplet,
    apiCall: addressSuggestionById.get({ suggestionId, iHandleStatusCodes }),
  });
